module.exports = __webpack_public_path__ + "media/photo/lady-92fa8e8b.jpg";